import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const TrimmedLength = (value: unknown): number => (typeof value === 'string' ? value.trim().length : 0);

export const TrimmedRequiredValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  TrimmedLength(control.value) > 0 ? null : { required: true };

export const TrimmedMaxLengthValidator =
  (max: number): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    const actualLength = TrimmedLength(control.value);

    return actualLength > max ? { maxlength: { requiredLength: max, actualLength } } : null;
  };
